// src/router/index.ts
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import MenuView from '../views/MenuView.vue';
import { auth } from '@/firebase'; // Import Firebase Auth

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'menu',
    component: MenuView
  },
  {
    path: '/advertisement',
    name: 'advertisement',
    component: () => import('../views/AdvertisementView.vue')
  },
  {
    path: '/game',
    name: 'game',
    component: () => import('../views/GameView.vue')
  },
  {
    path: '/results',
    name: 'results',
    component: () => import('../views/ResultsView.vue')
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import('../views/SolutionView.vue')
  },
  {
    path: '/stats',
    name: 'stats',
    component: () => import('../views/StatsView.vue')
  },
  {
    path: '/secreto',
    name: 'secreto',
    children: [
      {
        name: 'login',
        path: '',
        component: () => import('../views/LoginView.vue')
      },
      {
        name: 'admin',
        path: 'admin',
        component: () => import('../views/AdminView.vue'),
        // meta: { requiresAuth: true }
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

let previousRoute = '';
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const currentUser = auth.currentUser;

  previousRoute = from.name?.toString() || '';

  if (requiresAuth && !currentUser) {
    next({ name: 'menu'});
  } else {
    next();
  }
});

export { router, previousRoute };
export default router;
